import React from "react";
import classNames from "classnames";
import styles from "./ChevronIcon.css";

type Direction = "down" | "up" | "right" | "left";
interface Props {
  pointing?: Direction;
  clickable?: boolean;
  className?: string;
}
export const ChevronIcon = ({ className, pointing, clickable }: Props) => {
  return (
    <i
      className={classNames("icon-chevron-left", className, {
        [styles.left]: pointing === "left",
        [styles.down]: pointing === "down",
        [styles.up]: pointing === "up",
        [styles.clickable]: clickable
      })}
    />
  );
};
